export default {
    title: 'Shanta Securities Limited',
    description: 'Shanta Securities Limited is one of the top brokerage houses in Bangladesh with Innovative\n' +
        'Financial Services and Capital Market Solutions.',
    openGraph: {
        title: 'Shanta Securities Limited',
        description: 'Shanta Securities Limited is one of the top brokerage houses in Bangladesh with Innovative\n' +
            'Financial Services and Capital Market Solutions.',
        images: [
            {
                url: 'https://www.example.com/image.jpg',
                width: 800,
                height: 600,
                alt: 'Image Alt Text',
            },
        ],
    },
}